import getPriceLabelStringUtil from 'utils/string/get-price-label'

const FREE = 'FREE'

export default function getPriceOrFreeLabelStringUtil (price, options) {
  if (price === 0) {
    return FREE
  }

  return getPriceLabelStringUtil(price, options)
}
